<div [id]="id" *ngIf="dynamicHtml" [innerHTML]="dynamicHtml"></div>
